import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsCtx = createContext(null);

const FALLBACK = {
  telegram_bot_url: "https://t.me/V_vinko_bot",
  telegram_free_url: "https://telegram.me/+k9bRrvYK0HQ3OTM0",
  telegram_vip_url: "https://telegram.me/+k9bRrvYK0HQ3OTM0",
  telegram_vip_active: false,
  tiktok_url: "",
  tiktok_active: false,
  instagram_url: "https://www.instagram.com/v_vinko_/",
  whatsapp_url: "https://wa.me/message/5PKT62X65UW6E1",
  vinko_email: "fede.scalici.98@gmail.com",
  logo_url:
    "https://customer-assets.emergentagent.com/job_bet-assist-platform/artifacts/znun84qh_NUOVO%20LOGO%20VINKO.webp",
  notifications_email_active: true,
  notification_email: "fede.scalici.98@gmail.com",
  telegram_notifications_active: false,
  telegram_notify_bot_token: "",
  telegram_notify_chat_id: "",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);

  useEffect(() => {
    api
      .get("/settings")
      .then((r) => setSettings({ ...FALLBACK, ...r.data }))
      .catch(() => setSettings(FALLBACK));
  }, []);

  return <SettingsCtx.Provider value={settings}>{children}</SettingsCtx.Provider>;
}

export function useSettings() {
  return useContext(SettingsCtx) || FALLBACK;
}
